export default __webpack_public_path__ + "static/media/check-in-title-bg.76e43755.webp";